import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IntGroupExpComponent } from './int-group-exp.component';


const routes: Routes = [
  {
    path:'',
    component: IntGroupExpComponent
  },
  {
    path: ':folderId',
    loadChildren: () => import('./int-group-exp.module').then(m => m.IntGroupExpModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IntGroupExpRoutingModule { }
